var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRate = function SvgRate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 120"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    strokeWidth: 3,
    clipPath: "url(#rate_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 62,
    x: 1.5,
    y: 56.5,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 86,
    x: 41.5,
    y: 32.5,
    rx: 14
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 117,
    x: 80.5,
    y: 1.5,
    rx: 14
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rate_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h110v120H0z"
  })))));
};
export default SvgRate;